import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import useSWR from "swr";
import fetcher from "../utils/fetcher";

import "react-datepicker/dist/react-datepicker.css";
import styles from "../styles/home.module.css";
import regImg from "../assets/register.webp";
import { BsWhatsapp } from "react-icons/bs";
import { FaRegCheckCircle } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";
import { MdClose } from "react-icons/md";
import { FiCheck } from "react-icons/fi";

import SpecialOrderModal from "../components/specialOrderModal";
import HeroSection from "../components/home/HeroSection";
import FeatureBar from "../components/home/FeatureBar";
import CategoriesSection from "../components/home/CategoriesSection";
import BestSellersSection from "../components/home/BestSellersSection";
import ArSection from "../components/home/ArSection";
import VideoSection from "../components/home/VideoSection";
import CustomDesignSection from "../components/home/CustomDesignSection";
import StoriesSection from "../components/home/StoriesSection";
import TestimonialsSection from "../components/home/TestimonialsSection";
import CustomerHomesSection from "../components/home/CustomerHomesSection";

import BestsellingPanel from "../components/home/bestsellingPanel";
import {
  livingPanel, officePanel, entrancePanel, studentPanel, polePanel,
  corridorPanel, kitchenPanel, marriedPanel, bedroomPanel, abstractPanel,
  kidsPanel, graphPanel,
} from "../components/home/panels";

const Home = () => {
  const [activeTab, setActiveTab] = useState("bestselling");
  const [activeLabel, setActiveLabel] = useState("الأكثر مبيعاً");
  const [isVisible, setIsVisible] = useState(true);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [signLoading, setSignLoading] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const panelRef = useRef(null);
  const arRef = useRef(null);

  const { data: register } = useSWR(
    !user ? `${process.env.REACT_APP_BACKEND_URL}/api/features/register` : null,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateIfStale: true,
      shouldRetryOnError: (err) => err.status !== 304,
      errorRetryCount: 2,
    }
  );

  useEffect(() => {
    if (register) {
      setTimeout(() => {
        setShow(true);
      }, 10000);
    }
  }, [register]);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      const isNearBottom = scrollTop + windowHeight >= documentHeight - 200;
      setIsVisible(!isNearBottom);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.trim().replace(/\s+/g, " ") });
  };

  const handleSignup = async () => {
    setError("");
    try {
      setSignLoading(true);

      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/miniSignup`, formData);

      setShow(false);
      setSuccess(true);
    } catch (error) {
      console.error("Firebase Error:", error.code);

      let errorCode = "";
      let errorMessage = "An unknown error occurred. Please try again.";

      if (error.response?.data) {
        errorCode = error.response.data.data.code || "";
        errorMessage = error.response.data.data.message;
      }

      if (errorCode === "auth/email-already-exists") {
        errorMessage = "هذا البريد الإلكترونى مسجل بالفعل. من فضلك قم بتسجيل الدخول";
      }

      if (errorCode === "auth/internal-error" && errorMessage.includes("PASSWORD")) {
        errorMessage = "كلمة المرور يجب أن تكون من 10 إلى 20 عنصر وتحتوى على الأقل على حرف كبير و حرف صغير و رقم";
      }

      if (errorCode === "auth/invalid-email") {
        errorMessage = "البريد الإلكترونى غير صحيح";
      }

      setError(errorMessage);
    } finally {
      setSignLoading(false);
    }
  };

  const handleSelectCategory = (key, label) => {
    setActiveTab(key);
    if (label) setActiveLabel(label);
    panelRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const scrollToAr = () => {
    arRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const renderPanel = () => {
    switch (activeTab) {
      case "bestselling":
        return <BestsellingPanel />;
      case "living":
        return livingPanel();
      case "graph":
        return graphPanel();
      case "office":
        return officePanel();
      case "entrance":
        return entrancePanel();
      case "student":
        return studentPanel();
      case "pole":
        return polePanel();
      case "corridor":
        return corridorPanel();
      case "kitchen":
        return kitchenPanel();
      case "kids":
        return kidsPanel();
      case "married":
        return marriedPanel();
      case "bedroom":
        return bedroomPanel();
      case "abstract":
        return abstractPanel();
      default:
        return <BestsellingPanel />;
    }
  };

  return (
    <div className={styles.page}>
      {register && show && (
        <form
          className={styles.registerForm}
          onSubmit={(e) => { e.preventDefault(); handleSignup(); }}
        >
          <MdClose className="close over" onClick={() => setShow(false)} />

          <img src={regImg} alt="register" />

          <div className={`center ${styles.register}`}>
            <p>احصل على خصم 10% عند عمل حساب لك الآن</p>

            <input type="email" name="email" maxLength={100} placeholder="البريد الإلكترونى *" onChange={handleChange} required />

            <input type="password" name="password" maxLength={20} placeholder="كلمة المرور *" onChange={handleChange} required />

            <button type="submit" disabled={signLoading} className="buttonNoBorder">
              {signLoading ? (
                <ImSpinner2 className="smallspinner" />
              ) : (
                <FiCheck className="checkmark" style={{ stroke: "#a8825c" }} />
              )}{" "}
              أنشىء حساب
            </button>

            {error && <span className="error">{error}</span>}
          </div>

          <hr />
        </form>
      )}

      {success && (
        <div className="success center">
          <FaRegCheckCircle className="successIcon" />
          <span>تم إنشاء حسابك بنجاح</span>
          <p>اذهب إلى بريدك الإلكترونى واضغط على رابط التأكيد حتى تتمكن من تسجيل الدخول</p>
          <button onClick={() => navigate("/login")} className="good buttonBorder">حسناً</button>
        </div>
      )}

      <a href="https://wa.me/972543255575" target="_blank" rel="noreferrer">
        <BsWhatsapp className={`whatsapp ${styles.whatsRight} ${isVisible ? "showWhats" : "hideWhats"}`} />
      </a>

      <button onClick={() => setOpenModal(true)} className={styles.specialbtn}>
        صمم لوحتك
      </button>

      <HeroSection
        onBrowse={() => navigate("/products")}
        onCustom={() => setOpenModal(true)}
        onAr={scrollToAr}
      />

      {/* <FeatureBar /> */}

      <CategoriesSection activeTab={activeTab} onSelect={handleSelectCategory} />

      {/* <div ref={panelRef} className={styles.panelWrap}>
        {renderPanel()}
      </div> */}

      <BestSellersSection
        categoryId={activeTab === "bestselling" ? null : activeTab}
        title={activeLabel}
      />

      <div ref={arRef}>
        <ArSection onStart={() => navigate("/wall-preview")} />
      </div>

      <VideoSection />

      <CustomDesignSection onStart={() => setOpenModal(true)} />

      <StoriesSection onStart={() => setOpenModal(true)} />

      <TestimonialsSection />

      <CustomerHomesSection />

      <SpecialOrderModal isOpen={openModal} onClose={() => setOpenModal(false)} />
    </div>
  );
};

export default Home;
